// extracted by mini-css-extract-plugin
export default {"root":"Divider__root--4M-69r"};